import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { LkEuNotificationIconComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/notification-icon/lk-eu-notification-icon.component';
import { LkEuNotificationSidebarComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/notification-sidebar/lk-eu-notification-sidebar.component';
import { LkEuNotificationPanelComponent } from '@zaoblako/web/modules/lk/external-user/dumbs/notification-panel/lk-eu-notification-panel.component';
import { FormSidebarComponent } from '@zaoblako/web/shared/components/form-sidebar/form-sidebar.component';
import { UserAvatarComponent } from '@zaoblako/web/shared/components/user-avatar/user-avatar.component';
import { MenuItem } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { DialogService } from 'primeng/dynamicdialog';
import { MenubarModule } from 'primeng/menubar';

@Component({
  selector: 'crm-external-user-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    UserAvatarComponent,
    MenubarModule,
    BadgeModule,
    LkEuNotificationIconComponent,
    LkEuNotificationSidebarComponent,
    FormSidebarComponent,
    LkEuNotificationPanelComponent
  ],
  providers: [DialogService],
  templateUrl: './external-user-layout.component.html',
  styleUrls: ['./external-user-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ExternalUserLayoutComponent implements OnInit {
  @Input() public isShow = false;
  @Output() public isShowChange = new EventEmitter<boolean>();

  public readonly menuItems: MenuItem[] = [
    {
      label: 'Заявки',
      routerLink: '/lk/external-user/hd/list'
    },
    {
      label: 'Заявки на гостевой проезд',
      routerLink: '/lk/external-user/transit-task/list'
    }
  ];

  public constructor(public readonly authService: AuthService) {}

  public ngOnInit(): void {}
}
